/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './social-share.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../app/shared/social-share/social-share.component';
const styles_SocialShareComponent:any[] = [import0.styles];
export const RenderType_SocialShareComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_SocialShareComponent,
  data: {}
}
);
export function View_SocialShareComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'ssk-group ssk-round hm-ssk hidden-sm-down'
      ]
    ],[
      [
        2,
        'hm-ssk-grayscale',
        (null as any)
      ]
      ,
      [
        2,
        'ssk-xs',
        (null as any)
      ]
      ,
      [
        2,
        'ssk-sm',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'a',[
      [
        'class',
        'ssk ssk-facebook'
      ]
      ,
      [
        'href',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'a',[
      [
        'class',
        'ssk ssk-twitter'
      ]
      ,
      [
        'href',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'a',[
      [
        'class',
        'ssk ssk-linkedin'
      ]
      ,
      [
        'href',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[
      [
        'class',
        'ssk ssk-carrot comments-button'
      ]
      ,
      [
        'href',
        ''
      ]

    ]
      ,[[
        2,
        'hm-ssk-hidden',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.SocialShareComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showComments($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-commenting'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import2.SocialShareComponent = v.component;
    const currVal_0:any = co.isHeader;
    const currVal_1:any = co.isHeader;
    const currVal_2:boolean = !co.isHeader;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = co.isHeader;
    ck(v,8,0,currVal_3);
  });
}
function View_SocialShareComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'socialShare',([] as any[]),(null as any),(null as any),(null as any),View_SocialShareComponent_0,RenderType_SocialShareComponent)),
    import1.ɵdid(4767744,(null as any),0,import2.SocialShareComponent,[
      'isBrowser',
      import1.ElementRef,
      import1.Renderer2
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const SocialShareComponentNgFactory:import1.ComponentFactory<import2.SocialShareComponent> = import1.ɵccf('socialShare',import2.SocialShareComponent,View_SocialShareComponent_Host_0,{
  isHeader: 'isHeader',
  twitterText: 'twitterText',
  ogTitle: 'ogTitle',
  ogDescription: 'ogDescription'
}
,{onVisible: 'onVisible'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/social-share/social-share.component.ngfactory.ts